import React from 'react';

const SidebarLogoIcon = ({ ...props }) => (
  <img 
  src="/MSL-Favicon-2025.png"
    alt="MSL Logo" 
    style={{
      width: '45px',
      height: 'auto',
      objectFit: 'contain',
      ...props.style
    }}
  />
);
export default SidebarLogoIcon;
